import { createFileRoute } from '@tanstack/react-router'
import { CadastrarUsuario } from '@/features/cadastrar-usuario'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/cadastrar-usuario/')({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: CadastrarUsuario,
})

